import { LegalityChecker, DeckLeglaity } from '../deckLegality'
import { ERRORS } from '../legality.const'

const CheckLegality: LegalityChecker = (deck: DeckLeglaity) => {
  /***************** Oathbreaker & Signature Spell *******************/

  // prettier-ignore
  const signatureSpells = deck.commanders.filter(card => card.types.includes('Sorcery') || card.types.includes('Instant'))

  // prettier-ignore
  const faceWalkers = deck.commanders.filter(card => card.types.includes('Planeswalker') || card.text.includes('can be your commander'))

  let requiredNumberOfSignatureSpells = 1

  const oathbreaker = faceWalkers[0]
  const signatureSpell = signatureSpells[0]

  // Overwritting the default commander color ident here so as to better match the oathbreaker format
  deck.commandersColorIdent = deck.getCardsColorIdentity(faceWalkers)

  if (!oathbreaker) deck.addError('You need an Oathbreaker')
  else if (faceWalkers.length > 2)
    for (const walker of faceWalkers) deck.addCardError(ERRORS.SINGLE_OATHBREAKER, walker)

  if (faceWalkers.length === 2) {
    requiredNumberOfSignatureSpells = 2

    const partner = faceWalkers[1]
    const arePartners = oathbreaker.text.includes('Partner') && partner.text.includes('Partner')

    if (!arePartners) deck.addError(ERRORS.PARTNER_OATHBREAKERS)
    else {
      if (oathbreaker.text.includes('Partner with')) {
        if (!oathbreaker.text.includes(partner.name)) deck.addError(ERRORS.PARTNER_WITH_COMMANDERS)
        else if (!partner.text.includes(oathbreaker.name)) deck.addError(ERRORS.PARTNER_WITH_COMMANDERS)
      }
    }
  }

  if (!signatureSpell) deck.addError('You need a Signature Spell')
  else if (signatureSpells.length !== requiredNumberOfSignatureSpells)
    if (requiredNumberOfSignatureSpells === 1)
      for (const spell of signatureSpells) deck.addCardError(ERRORS.SINGLE_SIGNATURE_SPELL, spell)
    else if (requiredNumberOfSignatureSpells === 2)
      for (const spell of signatureSpells) deck.addCardError(ERRORS.PARTNER_SIGNATURE_SPELL, spell)

  const fullDeck = [...deck.commanders, ...deck.mainboard]

  for (const card of fullDeck) {
    deck.checkCardLegality(card)
    deck.checkCardQuantity(card, 1)

    if (deck.commanders.length) deck.checkCardColorIdentAgainstCommanders(card)
  }

  if (deck.deckSize !== 60) deck.addError(ERRORS.OATHBREAKER_SIZE)
}

export default CheckLegality
